import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'flattenDeliverySurcharges',
  initialState: false,
  reducers: {
    setFlattenDeliverySurcharges(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setFlattenDeliverySurcharges } = slice.actions;

export default slice.reducer;
